import { Link as ReactRouterLink } from 'react-router-dom'
import { Box, Button } from '@chakra-ui/react'

export const Header = () => {
  return (
    <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
      <ReactRouterLink className={'ml-6 rounded-full'} to={'/home'}>
        <Button
          as={'div'}
          variant={'brand-solid-white'}
          rounded={'full'}
          px={'1.15rem'}
          display={{
            base: 'none',
            sm: 'flex',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="18"
            viewBox="0 0 17 18"
            fill="none"
          >
            <line
              x1="7.83213"
              y1="16.9257"
              x2="1.17006"
              y2="9.52337"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <line
              x1="1"
              y1="-1"
              x2="10.9588"
              y2="-1"
              transform="matrix(-0.668965 0.743294 0.743294 0.668965 9.24438 1)"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <line
              x1="15.3556"
              y1="9.10937"
              x2="1.00004"
              y2="9.10937"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>{' '}
          &nbsp;&nbsp;&nbsp;All interviews
        </Button>
      </ReactRouterLink>
    </Box>
  )
}
